`<template lang="pug">
  div
    event-header(
      v-if='isRecordEventsData'
      title="Events"
      :eventQuantity="tableData.length"
      )

      collapse-timeline-component(
        v-for='({groupType, events}, i) in tableData'
        :key="groupType + i"
        :eventTitle="groupType",
        :eventDate="events[0].recordedDate || null"
        :eventType="events[0].status")
        record-events-row(
          v-for='event of events'
          :key='event.type + event.recordedDate'
          :item="event"
          )
    template(v-else)
      h4.title No events history available

</template>

<script>
import CollapseTimelineComponent from '@/components/lei-components/CollapseTimelineComponent'
import EventHeader from '@/components/record-details/modifications/EventHeader'
import RecordEventsRow from '@/components/record-details/modifications/RecordEventsRow'


export default {
  name: 'RecordEventsBlock',
  components: {
    EventHeader,
    CollapseTimelineComponent,
    RecordEventsRow,
  },

  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    isRecordEventsData () {
      return this.tableData.length > 0
    },
  },
}
</script>

<style scoped lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .modifications-row-wrap
    width: 100%

  .show-more__btn
    margin-top: 20px

</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/RecordEventsBlock.vue